/**
 *  Global Card Component
 *  Author: Teemo
 *  CreatedAt: 2021-03-03
 */
import React from 'react';
import { Card as CardAntd } from 'antd';

const Card = (props) => {
  const { children, ...rest } = props;
  return <CardAntd {...rest}>{children}</CardAntd>;
};
export default Card;
